// extracted by mini-css-extract-plugin
module.exports = {"Select":"news-sport-select_Select__epXdh"};